export const TWO_UP_LEFT_WIDE = '2 Up Left Wide'
export const TWO_UP_RIGHT_WIDE = '2 Up Right Wide'
export const PADDING = 'Padding'
